import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './styles/OverviewTabs.css';
import { useAppEmailVerificationRestricted } from '../email-verification/EmailVerificationRestrictionContext';
import { APP_EMAIL_VERIFICATION_LOCK_TITLE } from '../email-verification/appEmailVerificationRestriction';
import '../email-verification/appEmailVerificationLock.css';

const OverviewTabs = ({ appointmentCount = 0, meetingCount = 0 }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const navigationLocked = useAppEmailVerificationRestricted();

  const isOverview = location.pathname === '/app/overview';
  const isMeetings = location.pathname.startsWith('/app/overview/meetings');
  const hasMeetings = meetingCount > 0;
  /* Show tabs when there are meetings, or when on a meetings route (so user can switch back to Appointments) */
  const showTabs = (isOverview || isMeetings) && (hasMeetings || isMeetings);

  if (!showTabs) return null;

  return (
    <nav
      className={`overview-tabs${navigationLocked ? ' overview-tabs--locked' : ''}`}
      role="tablist"
      aria-label="Appointments and Meetings"
    >
      <ul className="overview-tabs__list">
        <li className="overview-tabs__tab" role="presentation">
          <button
            type="button"
            role="tab"
            id="tab-appointments"
            aria-selected={isOverview}
            aria-controls="overview-panel"
            className="overview-tabs__btn overview-tabs__btn--allowed"
            onClick={() => navigate('/app/overview')}
          >
            <span className="overview-tabs__label">Appointments</span>
            {appointmentCount > 0 && (
              <span className="overview-tabs__badge" aria-label={`${appointmentCount} appointments`}>
                {appointmentCount > 99 ? '99+' : appointmentCount}
              </span>
            )}
          </button>
        </li>
        <li className="overview-tabs__tab" role="presentation">
          <button
            type="button"
            role="tab"
            id="tab-meetings"
            aria-selected={isMeetings}
            aria-controls="meetings-panel"
            className="overview-tabs__btn"
            onClick={navigationLocked ? undefined : () => navigate('/app/overview/meetings')}
            disabled={navigationLocked}
            title={navigationLocked ? APP_EMAIL_VERIFICATION_LOCK_TITLE : undefined}
          >
            <span className="overview-tabs__label">Meetings</span>
            {meetingCount > 0 && (
              <span className="overview-tabs__badge" aria-label={`${meetingCount} meetings`}>
                {meetingCount > 99 ? '99+' : meetingCount}
              </span>
            )}
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default OverviewTabs;
